import { WidgetPosition } from '@shareview/sessionmanager-api-client';
import { CastLayoutType } from '../types';

export interface CastingStateModel {
  sessionId: string | null;
  layout: CastLayoutType | null;
  widgets: WidgetPosition[];
}

export const DEFAULT_STATE: CastingStateModel = {
  sessionId: null,
  layout: null,
  widgets: []
};
